import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const ProfileSettings = React.lazy(() => import('../pages/ProfileSettings'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const settingsRoutes = (
  <>
    <Route path="/settings" element={<SuspenseWrapper><ProfileSettings /></SuspenseWrapper>} />
  </>
);
